<template>
    <div v-if="showLoader" style="text-align:center; min-height: 200px">
        <div class="loader-override" ></div>
        <span>Carregando informações...</span>
    </div>
</template>

<script>
export default {
  name: "Loader",
  components: {
  },
  props: ['show-loader']
}
</script>

<style>
.loader-override {
	z-index: 10000;
	display: block;
	border: 4px solid #f3f3f3;
	border-top: 4px solid rgb(174, 95, 44);
	border-radius: 50%;
	width: 40px;
  height: 40px;
  margin: 0 auto;
	animation: spin 2s linear infinite;
}
</style>